const breastCancerPrediction = {
  fa: {
    header: {
      title: "پیش‌بینی سرطان سینه",
      intro:
        "پیش‌بینی سرطان سینه یک پروژه یادگیری ماشین برای دسته‌بندی داده‌های مربوط به سرطان سینه است که با استفاده از Random Forest Classifier و مجموعه‌داده استاندارد UCI توسعه داده شده است.",
      description: [
        "تمرکز اصلی پروژه بر بهبود کیفیت داده پیش از آموزش مدل قرار دارد. در این فرایند، داده‌ها بررسی و پاک‌سازی شده‌اند و نمونه‌های پرت شناسایی و حذف شده‌اند. همچنین ویژگی‌ها به منظور ایجاد توزیع مناسب‌تر برای مدل، به توزیع نرمال تبدیل شده‌اند.",

        "پس از آماده‌سازی داده‌ها، مدل Random Forest آموزش داده شده و عملکرد آن روی داده‌های آموزش و آزمون بررسی شده است. در بهترین اجرای ثبت‌شده در پروژه، مدل به 99.03٪ دقت روی داده‌های آزمون دست یافته است.",

        "پروژه همچنین شامل Notebook مربوط به فرایند آموزش و آزمایش مدل و نمودارهایی برای مشاهده توزیع ویژگی‌ها پیش و پس از فرایند پاک‌سازی و تبدیل داده است.",
      ],
      image:
        "https://github.com/F-Yousefi/Breast_Cancer_Prediction/raw/main/images/header.png",
    },
    side: {
      Project: "Breast Cancer Prediction",
      LiveDemo: "https://github.com/F-Yousefi/Breast_Cancer_Prediction",
      Language: "انگلیسی",
      Date: "مهر ۱۴۰۲",
      Technologies:
        "Linear Regression · Random Forest · Data Cleaning · Outlier Detection · Feature Transformation · Model Evaluation · 99.03% Test Accuracy",
    },
  },

  en: {
    header: {
      title: "Breast Cancer Prediction",
      intro:
        "Breast Cancer Prediction is a machine learning classification project that uses a Random Forest Classifier to analyze breast cancer data from the UCI dataset.",
      description: [
        "A major focus of the project is improving the quality of the input data before training. The preprocessing pipeline identifies and removes outliers and transforms the features toward a normal distribution, helping create a cleaner and more consistent dataset.",

        "After preprocessing, multiple Random Forest models are trained and evaluated on separate training and test data. The best recorded model achieves 99.03% test accuracy, demonstrating the impact of careful data preparation and model optimization.",
        "The project also includes a Jupyter Notebook and visualizations that illustrate the changes in feature distributions before and after preprocessing.",
      ],
      image:
        "https://github.com/F-Yousefi/Breast_Cancer_Prediction/raw/main/images/header.png",
    },
    side: {
      Project: "Breast Cancer Prediction",
      LiveDemo: "https://github.com/F-Yousefi/House_Price_Prediction",
      Language: "English",
      Date: "October 2023",
      Technologies:
        "Linear Regression · Random Forest · Data Cleaning · Outlier Detection · Feature Transformation · Model Evaluation · 99.03% Test Accuracy",
    },
  },
};

export default breastCancerPrediction;
